;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"LaFCnVEQmB1NQVsCLYJpu"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { init } from '@sentry/nextjs';
import { SENTRY_IGNORE_ERRORS } from '@packages/shared/core/common/constants';
import { guidanceConfig } from 'src/config';

init({
  dsn: guidanceConfig.sentryDsn,
  tracesSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  release: guidanceConfig.appVersion,
  debug: true,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
  ignoreErrors: SENTRY_IGNORE_ERRORS,
  initialScope: {
    tags: { app: guidanceConfig.appName },
  },
  integrations: function (integrations) {
    // integrations will be all default integrations
    return integrations.filter(function (integration) {
      return integration.name !== 'BrowserTracing';
    });
  },
});
